export default "__VITE_ASSET__ChoXccrq__"